import * as React from "react";
const OffersAvailable = (props:any) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.56976 16.0201C8.37976 16.0201 8.18977 15.9501 8.03977 15.8001C7.74977 15.5101 7.74977 15.0301 8.03977 14.7401L14.5898 8.19016C14.8798 7.90016 15.3598 7.90016 15.6498 8.19016C15.9398 8.48016 15.9398 8.96015 15.6498 9.25015L9.09976 15.8001C8.94976 15.9501 8.75976 16.0201 8.56976 16.0201Z"
      fill="var(--color-blue)"
    />
    <path
      d="M8.98001 11.1099C7.89001 11.1099 7 10.2199 7 9.12991C7 8.03991 7.89001 7.1499 8.98001 7.1499C10.07 7.1499 10.96 8.03991 10.96 9.12991C10.96 10.2199 10.07 11.1099 8.98001 11.1099ZM8.98001 8.65991C8.72001 8.65991 8.5 8.86992 8.5 9.13992C8.5 9.40992 8.71001 9.6199 8.98001 9.6199C9.25001 9.6199 9.45999 9.40992 9.45999 9.13992C9.45999 8.86992 9.24001 8.65991 8.98001 8.65991Z"
      fill="var(--color-blue)"
    />
    <path
      d="M15.52 16.8399C14.43 16.8399 13.54 15.9499 13.54 14.8599C13.54 13.7699 14.43 12.8799 15.52 12.8799C16.61 12.8799 17.5 13.7699 17.5 14.8599C17.5 15.9499 16.61 16.8399 15.52 16.8399ZM15.52 14.3899C15.26 14.3899 15.04 14.5999 15.04 14.8699C15.04 15.1399 15.25 15.3499 15.52 15.3499C15.79 15.3499 16 15.1399 16 14.8699C16 14.5999 15.79 14.3899 15.52 14.3899Z"
      fill="var(--color-blue)"
    />
    <path
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      fill="var(--color-blue)"
    />
  </svg>
);
export default OffersAvailable;
